import { Outlet, Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "./AuthContext";
import { 
  FaHome, FaChartLine, FaCalendarAlt, FaTasks, FaClipboardCheck,
  FaVoteYea, FaAward, FaFileAlt, FaFolder, FaClipboardList, 
  FaBullhorn, FaComments, FaPoll, FaUsers, FaBars, FaTimes, 
  FaSignOutAlt, FaStickyNote
} from "react-icons/fa";

export default function Layout() {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, logout } = useAuth();

  const navItems = [
    { path: "/", label: "Home", icon: <FaHome /> },
    { path: "/dashboard", label: "Dashboard", icon: <FaChartLine /> },
    { path: "/meetings", label: "Meetings", icon: <FaCalendarAlt /> },
    { path: "/tasks", label: "Tasks", icon: <FaTasks /> },
    { path: "/action-items", label: "Action Items", icon: <FaClipboardCheck /> },
    { path: "/attendance", label: "Attendance", icon: <FaClipboardCheck /> },
    { path: "/votes", label: "Internal Votes", icon: <FaVoteYea /> },
    { path: "/nominations", label: "Nominations", icon: <FaAward /> },
    { path: "/elections", label: "Elections", icon: <FaPoll /> },
    { path: "/documents", label: "Documents", icon: <FaFileAlt /> },
    { path: "/resources", label: "Resource Library", icon: <FaFolder /> },
    { path: "/minutes", label: "Meeting Minutes", icon: <FaClipboardList /> },
    { path: "/committee-notes", label: "Committee Notes", icon: <FaStickyNote /> },
    { path: "/noticeboard", label: "Noticeboard", icon: <FaBullhorn /> },
    { path: "/messageboard", label: "Message Board", icon: <FaComments /> },
    { path: "/members", label: "Members", icon: <FaUsers /> },
  ];

  return (
    <div style={{ minHeight: "100vh", display: "flex" }}>
      {/* Sidebar */}
      <aside
        style={{
          width: sidebarOpen ? "280px" : "80px",
          minHeight: "100vh",
          background: "linear-gradient(180deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          transition: "width 0.3s ease",
          boxShadow: "2px 0 10px rgba(0,0,0,0.1)",
          position: "relative",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            padding: "20px",
            borderBottom: "1px solid rgba(255,255,255,0.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h1
            style={{
              margin: 0,
              fontSize: "20px",
              fontWeight: "600",
              opacity: sidebarOpen ? 1 : 0,
              transition: "opacity 0.3s",
              whiteSpace: "nowrap",
            }}
          >
            Staff Council
          </h1>
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            style={{
              background: "rgba(255,255,255,0.2)",
              border: "none",
              color: "white",
              padding: "8px 10px",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "18px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {sidebarOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        <nav style={{ flex: 1, padding: "20px 0", overflowY: "auto" }}>
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                  padding: "15px 20px",
                  textDecoration: "none",
                  color: "white",
                  background: isActive ? "rgba(255,255,255,0.15)" : "transparent",
                  borderLeft: isActive ? "4px solid white" : "4px solid transparent",
                  transition: "all 0.2s",
                  marginBottom: "5px",
                }}
                onMouseEnter={(e) => {
                  if (!isActive) e.currentTarget.style.background = "rgba(255,255,255,0.1)";
                }}
                onMouseLeave={(e) => {
                  if (!isActive) e.currentTarget.style.background = "transparent";
                }}
              >
                <span style={{ fontSize: "20px", minWidth: "20px" }}>{item.icon}</span>
                <span
                  style={{
                    opacity: sidebarOpen ? 1 : 0,
                    transition: "opacity 0.3s",
                    whiteSpace: "nowrap",
                    fontWeight: isActive ? "600" : "400",
                  }}
                >
                  {item.label}
                </span>
              </Link>
            );
          })}
        </nav>

        {/* User Profile Section */}
        <div
          style={{
            padding: "20px",
            borderTop: "1px solid rgba(255,255,255,0.1)",
            background: "rgba(0,0,0,0.1)",
            flexShrink: 0,
          }}
        >
          {user && (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  marginBottom: "12px",
                  opacity: sidebarOpen ? 1 : 0,
                  transition: "opacity 0.3s",
                }}
              >
                {user.picture && (
                  <img
                    src={user.picture}
                    alt={user.name}
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      border: "2px solid rgba(255,255,255,0.3)",
                    }}
                  />
                )}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{
                      fontWeight: "600",
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {user.name}
                  </div>
                  <div
                    style={{
                      fontSize: "12px",
                      opacity: 0.8,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {user.email}
                  </div>
                </div>
              </div>
              <button
                onClick={logout}
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: sidebarOpen ? "center" : "center",
                  gap: "8px",
                  padding: "10px",
                  background: "rgba(255,255,255,0.2)",
                  border: "none",
                  borderRadius: "6px",
                  color: "white",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                  transition: "all 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(255,255,255,0.3)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "rgba(255,255,255,0.2)";
                }}
              >
                <FaSignOutAlt style={{ fontSize: "16px" }} />
                <span
                  style={{
                    opacity: sidebarOpen ? 1 : 0,
                    transition: "opacity 0.3s",
                    whiteSpace: "nowrap",
                  }}
                >
                  Sign Out
                </span>
              </button>
            </>
          )}
        </div>
      </aside>

      {/* Main Content Area */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {/* Header */}
        <header
          style={{
            background: "#fff",
            padding: "20px 40px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <h2 style={{ margin: 0, fontSize: "24px", color: "#2d3748", fontWeight: "600" }}>
            {navItems.find((item) => item.path === location.pathname)?.label || "Home"}
          </h2>
        </header>

        {/* Main Content */}
        <main style={{ flex: 1, background: "#f5f7fa", overflow: "auto" }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}

